import { ClickableProps, useClickableContext } from '@web/ui/components/Clickable/context'

export default function Clickable(props: ClickableProps) {
  const ContextClickable = useClickableContext()
  return <ContextClickable {...props} />
}
